// /**
//  * Center - Add
//  */

// React
import React, {useState, useEffect} from 'react';

// react hook form
import {Controller, useForm} from 'react-hook-form';

// UI
import {
  TextField,
  Grid,
  Button,
  CardContent,
  Card,
  FormHelperText,
  Dialog,
  DialogContent,
} from '@material-ui/core';

// Type
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import ContactsRepository from 'client-sdk/src/Repository/contacts-repository';
import handleError from '../../../utils/handleError';
import handleNotfication from '../../../utils/handleNotfication';
import {Autocomplete} from '@material-ui/lab';
import CommonRepository from 'client-sdk/src/Repository/common-repository';
import MapPosition from '../../centers/components/mapPosition';
import { Router, useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import RonadIcons from '../../../components/iconComponent';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    item: {
      display: 'flex',
      alignItems: 'end',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    text: {
      width: '100%',
    },
    errorText: {
      alignSelf: 'inherit',
      color: '#F30000',
      fontSize: '11px',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '12px',
      marginTop: '21px',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      marginBottom: '24px',
      overflow: 'visible',
      paddingBottom: '0',
    },

    cardContent: {
      justifyContent: 'space-between',
      //   paddingLeft: '14px',
    },
    cardContentOrder: {
      paddingBottom: '10px',
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
  })
);

type Inputs = {
  name: string;
  nationalCode: string;
  phoneNumber: string;
  province: string;
  city: string;
  postalCode: string;
  address: string;
};

const validateNumber = value => {
  if (!value) {
    return true;
  }

  const pattern = /^[0-9]+$/;
  return pattern.test(value);
};

function AddContact(props: any) {
  const classes = useStyles();
  const history = useHistory();
  const {register, handleSubmit, errors, control, getValues, setValue, reset} =
    useForm<Inputs>({
      mode: 'onChange',
    })
  const [provincesList, setProvincesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [location, setLocations] = useState<{lat: number; lng: number}>({
    lat: 0,
    lng: 0,
  });
  const [openLocation, setOpenLocation] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [id, setId] = useState();
  const { search } = useLocation()
  const mobile = queryString.parse(search)?.mobile
  const values = getValues()

  const handleCloseModal = () => {
    setOpenLocation(false);
  };

  useEffect(() => {
    if(mobile) {
      setEditMode(true)
      getSingleContact(mobile)
    }
    getProvinces();
  }, []);

  const handleLocations = (data: {lat: number; lng: number}) => {
    setLocations(data);
  };

  const getSingleContact = async (mobileNumber: string) => {
    try {
      const response = await ContactsRepository.getContactWithId({payload: {id: mobileNumber}})
      const {fullName, mobile, postalCode, address, city, province,nationalCode ,lat, lon, id} = response.data;
      reset({
        name: fullName,
        phoneNumber: mobile,
        address,
        city: city,
        province: province,
        nationalCode,
        postalCode,
      })
      setLocations({lat,lng: lon})
      setId(id)
    } catch (error) {
      handleError(error)
    }
  }

  const onSubmit = async (data: any) => {
    if(editMode) {
      updateContact(data)
    }else {
      createContact(data)
    }
  };

  const createContact = async (data: any) => {
    const {name, phoneNumber, postalCode, address, city, province,nationalCode} = data;
    const {lat, lng} = location;
    try {
      await ContactsRepository.createContact({
        payload: {
          data: {
            fullName: name,
            mobile: phoneNumber.length > 0 ? phoneNumber : null,
            address,
            nationalCode,
            city: city,
            province: province,
            postalCode,
            lat,
            lon: lng,
          },
        },
      });
      handleNotfication('مخاطب جدید با موفقیت ایجاد شد', 'success');
      history.push("/contacts")
    } catch (error) {
      handleError(error);
    }
  }

  const updateContact = async (data: any) => {
    const {name, phoneNumber, postalCode, address, city, province, nationalCode} = data;
    const {lat, lng} = location;
    try {
      await ContactsRepository.updateContact({
        payload: {
          body: {
            id,
            fullName: name,
            mobile: phoneNumber.length > 0 ? phoneNumber : null,
            address,
            city: city,
            province: province,
            nationalCode,
            postalCode,
            lat,
            lon: lng,
          },
        },
      });
      handleNotfication('مخاطب جدید با موفقیت ویرایش شد', 'success');
      history.push("/contacts")
    } catch (error) {
      handleError(error);
    }
  }

  const getProvinces = async () => {
    try {
      const response = await CommonRepository.getProvinces({payload: {}});
      setProvincesList(response.data);
    } catch (err) {
      handleError(err);
    }
  };

  const getCities = async (provinceId: number) => {
    try {
      const response = await CommonRepository.getCities({
        payload: {'provinceId.equals': provinceId},
      });
      setCitiesList(response.data);
    } catch (err) {
      handleError(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{backgroundColor: '#fff', borderRadius: '4px', padding: '24px'}}
    >
      <Grid container>
        <Grid xs={12} item>
          <p className="typography-cards">مخاطب جدید</p>
          <Card className={classes.card}>
            <CardContent className={classes.cardContentOrder}>
              <Grid container className={classes.cardContent} spacing={2}>
                <Grid
                  container
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  lg={4}
                  alignItems="flex-end"
                >
                  <div className={classes.item}>
                    <div style={{width: '100%'}}>
                      <Controller
                        style={{width: '100%'}}
                        control={control}
                        name="name"
                        label="نام و نام خانوادگی"
                        rules={{
                          required: true,
                        }}
                        as={
                          <TextField
                            name="name"
                            // label="نام و نام خانوادگی"
                            type="search"
                            variant="outlined"
                            fullWidth
                            id="name"
                            InputLabelProps={{
                              shrink: values.name,
                            }}
                            error={
                              !!errors.name && !!errors.name
                            }
                          />
                        }
                      />
                      <FormHelperText error focused>
                        {errors.name && 'نام و نام خانوادگی الزامی میباشد'}
                      </FormHelperText>
                    </div>
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  lg={4}
                  alignItems="flex-start"
                >
                  <div className={classes.item}>
                    <div style={{width: '100%'}}>
                      <Controller
                        style={{width: '100%'}}
                        control={control}
                        name="nationalCode"
                        label="کد ملی (۱۰ رقمی)"
                        rules={{
                          required: false,
                          minLength: 10,
                          maxLength: 10,
                          validate: validateNumber,
                        }}
                        as={
                          <TextField
                            type="search"
                            variant="outlined"
                            fullWidth
                            id="nationalCode"
                            InputLabelProps={{
                              shrink: values.nationalCode,
                            }}
                            inputRef={register({
                              required: false,
                              minLength: 10,
                              maxLength: 10,
                              pattern: /[0-9]/,
                            })}
                            error={
                              !!errors.nationalCode &&
                              !!errors.nationalCode
                            }
                          />
                        }
                      />
                      <FormHelperText error focused>
                        {errors.nationalCode?.type === 'required' &&
                          'کد ملی الزامی میباشد'}
                      </FormHelperText>
                      <FormHelperText error focused>
                        {(errors.nationalCode?.type === 'minLength' ||
                          errors.nationalCode?.type === 'maxLength') &&
                          'کد ملی 10 رقم میباشد'}
                      </FormHelperText>
                      <FormHelperText error focused>
                        {errors.nationalCode?.type === 'validate' &&
                          'لطفا عدد انگلیسی وارد کنید'}
                      </FormHelperText>
                    </div>
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  lg={4}
                  alignItems="flex-start"
                >
                  <div className={classes.item}>
                    <div dir="rtl" style={{width: '100%'}}>
                      <Controller
                        style={{width: '100%'}}
                        control={control}
                        name="phoneNumber"
                        InputLabelProps={{
                          shrink: values.phoneNumber,
                        }}
                        label=" شماره همراه (۰۹۱۲۳۴۵۶۷۸۹)"
                        rules={{
                          required: true,
                          minLength: 11,
                          maxLength: 11,
                          pattern: /[0-9]/,
                        }}
                        as={
                          <TextField
                            type="search"
                            variant="outlined"
                            fullWidth
                            id="phoneNumber"
                            error={
                              !!errors.phoneNumber &&
                              !!errors.phoneNumber
                            }
                          />
                        }
                      />
                      <FormHelperText error focused>
                        {errors.phoneNumber?.type === 'required' &&
                          'شماره‌همراه الزامی می باشد'}
                      </FormHelperText>
                      <FormHelperText error focused>
                        {(errors.phoneNumber?.type === 'minLength' ||
                          errors.phoneNumber?.type === 'maxLength') &&
                          'شماره‌همراه سفارش‌دهنده 11 رقم می باشد'}
                      </FormHelperText>
                      <FormHelperText error focused>
                        {errors.phoneNumber?.type === 'validate' &&
                          'لطفا عدد انگلیسی وارد کنید'}
                      </FormHelperText>
                    </div>
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  alignItems="flex-start"
                >
                  <div className={classes.item}>
                    <div style={{width: '100%'}}>
                      <Controller
                        name="province"
                        control={control}
                        defaultValue=""
                        rules={{required: true}}
                        render={({value}) => (
                          <Autocomplete
                            noOptionsText="موردی یافت نشد"
                            getOptionSelected={(option, value) =>
                              option.name === value?.name
                            }
                            getOptionLabel={option => option.name}
                            options={provincesList}
                            inputValue={value}
                            onChange={(event: any, newValue: any) => {
                              setValue('city', '');
                              getCities(newValue?.id);
                              setValue('province', newValue?.name);
                            }}
                            renderInput={params => (
                              <TextField
                                {...params}
                                label="استان"
                                variant="outlined"
                                onChange={e =>
                                  setValue('province', e.target.value)
                                }
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>
                                      {params.InputProps.endAdornment}
                                    </React.Fragment>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                      <FormHelperText error focused>
                        {errors?.province &&
                          'استان الزامی میباشد'}
                      </FormHelperText>
                    </div>
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  alignItems="flex-start"
                >
                  <div className={classes.item}>
                    <div style={{width: '100%'}}>
                      <Controller
                        name="city"
                        control={control}
                        defaultValue=""
                        rules={{required: true}}
                        render={({value}) => (
                          <Autocomplete
                            noOptionsText="موردی یافت نشد"
                            getOptionSelected={(option, value) =>
                              option.name === value?.name
                            }
                            getOptionLabel={option => option.name}
                            options={citiesList}
                            inputValue={value}
                            onChange={(event: any, newValue: any) => {
                              setValue('city', newValue?.name);
                            }}
                            renderInput={params => (
                              <TextField
                                {...params}
                                label="شهر"
                                variant="outlined"
                                // inputRef={register({ required: true })}
                                // InputLabelProps={{ shrink: true }}
                                onChange={e =>
                                  setValue('city', e.target.value)
                                }
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>
                                      {params.InputProps.endAdornment}
                                    </React.Fragment>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                      <FormHelperText error focused>
                        {errors?.city && 'شهر الزامی میباشد'}
                      </FormHelperText>
                    </div>
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  alignItems="flex-start"
                >
                  <div className={classes.item}>
                    <div style={{width: '100%'}}>
                      <Controller
                        style={{width: '100%'}}
                        control={control}
                        name="postalCode"
                        InputLabelProps={{
                          shrink: values.postalCode,
                        }}
                        label="کد پستی (۱۰ رقمی)"
                        rules={{
                          required: false,
                          maxLength: 10,
                          minLength: 10,
                          validate: validateNumber,
                        }}
                        as={
                          <TextField
                            type="search"
                            variant="outlined"
                            fullWidth
                            id="postalCode"
                            inputRef={register({
                              required: false,
                              minLength: 10,
                              maxLength: 10,
                              pattern: /[0-9]/,
                            })}
                            error={
                              !!errors.postalCode &&
                              !!errors.postalCode
                            }
                          />
                        }
                      />
                      <FormHelperText error focused>
                        {errors?.postalCode?.type === 'required' &&
                          'کد پستی الزامی میباشد'}
                      </FormHelperText>
                      <FormHelperText error focused>
                        {(errors.postalCode?.type === 'minLength' ||
                          errors.postalCode?.type === 'maxLength') &&
                          'کد پستی 10 رقم می باشد'}
                      </FormHelperText>
                      <FormHelperText error focused>
                        {errors.postalCode?.type === 'validate' &&
                          'لطفا عدد انگلیسی وارد کنید'}
                      </FormHelperText>
                    </div>
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={8}
                  md={8}
                  lg={8}
                  alignItems="flex-end"
                >
                  <div className={classes.item}>
                    <div style={{width: '100%'}}>
                      <Controller
                        style={{width: '100%'}}
                        control={control}
                        name="address"
                        label="آدرس گیرنده"
                        InputLabelProps={{
                          shrink: values.address,
                        }}
                        rules={{
                          required: true,
                        }}
                        as={
                          <TextField
                            type="search"
                            variant="outlined"
                            label="آدرس گیرنده"
                            fullWidth
                            id="address"
                            name="address"
                            error={
                              !!errors.address &&
                              !!errors.address
                            }
                          />
                        }
                      />
                      <FormHelperText error focused>
                        {errors?.address && 'آدرس الزامی میباشد'}
                      </FormHelperText>
                    </div>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={4} md={4} lg={4}>
                  <div className={classes.item}>
                    {location?.lat === 0 ? (
                      <Button
                        variant="outlined"
                        // className={classes.addProductIcon}
                        // color="primary"
                        size="large"
                        onClick={() => setOpenLocation(true)}
                        data-cy="addProduct"
                        style={{
                          width: '100%',
                          height: '56px',
                          marginBottom: '2px',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{'اضافه کردن موقعیت مکانی'}</span>
                        <RonadIcons name='plusCircleOutline' className='text-primary'/>
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        // className={classes.addProductIcon}
                        // color="primary"
                        onClick={() => setOpenLocation(true)}
                        size="large"
                        style={{
                          width: '100%',
                          height: '56px',
                          marginBottom: '2px',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                        data-cy="addProduct"
                      >
                        <span>{'موقعیت شما با موفقیت ثبت شد'}</span>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#32CD32',
                          }}
                        >
                          <RonadIcons name='checkCircle' size={0.8} className='text-green'/>
                        </span>
                      </Button>
                    )}
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Grid container justifyContent="flex-end">
            <Button
              type="submit"
              size="medium"
              data-cy="saveBtn"
              variant="contained"
              color="primary"
            >
              {editMode ? "ذخیره تغییرات" :"ذخیره"}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={openLocation}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{padding: '16px'}}
      >
        <Grid container>
          {/* <form > */}
          <DialogContent style={{paddingTop: '0'}}>
            <Grid item md={12} lg={12} style={{height: '440px'}}>
              <div
                style={{
                  width: '100%',
                  paddingTop: '64px',
                  paddingBottom: '15px',
                  borderBottom: '1px solid #cccccc',
                }}
              >
                <MapPosition
                  zoom={14}
                  style={{
                    width: '300',
                    height: '300px',
                    border: 'solid 2px gray',
                    marginTop: '-40px',
                    borderRadius: '4px',
                  }}
                  center={
                    location?.lat !== 0
                      ? location
                      : {
                          lat: 35.6892,
                          lng: 51.389,
                        }
                  }
                  position={location}
                  setLatlng={(latLng: {lat: number; lng: number}) => {
                    handleLocations(latLng);
                  }}
                />
              </div>
              <div style={{margin: '25px 0', textAlign: 'center'}}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleCloseModal}
                >
                  {`تایید`}
                </Button>
              </div>
            </Grid>
          </DialogContent>
        </Grid>
      </Dialog>
    </form>
  );
}

export default AddContact;
